import { Injectable, Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { AbstractRender } from "src/app/abstract/render.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";
import { Logger } from "src/app/core/logger";
import { WidgetsColumnModel } from "src/app/models/widgets/widgets-column.model";
import { RenderService } from "./render.service";

@Injectable({
  providedIn: 'root'
})
export class RenderColumnService extends AbstractRender {
  constructor(
    private injector: Injector,
    private logger: Logger
  ) {
    super();
  }

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
  render(widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean,
  ) {

    let field: FormlyFieldConfig;

    try {
      if (widget instanceof WidgetsColumnModel) {
        const currentWidget = widget as WidgetsColumnModel;

        // Auto width logic
        const columnWidth = this.isAutoWidthLogicNeeded(currentWidget) ? this.getAutoWidth(currentWidget) : currentWidget.width;

        isInsideQuestion = false;
        field = {};
        if (!isInsideQuestion) {
          field.props = {};
          field.props.fxFlex = columnWidth;
          field.props.description = 'COLUMN';
          field.className = 'primitive-column';
        }

        // Mix created input with widget template
        if (widget.template) {
          const modelTemplate = JSON.parse(widget.template);
          field = { ...modelTemplate, ...field };
          // Deep merge not working... Merge props manually
          const mergedprops = {
            ...field.props,
            ...modelTemplate.props,
          };
          field.props = mergedprops;
        }
        field.fieldGroup = [];
        config.push(field);

        // FIXME: formlyRoot overwritten with ROW. Is this right?
        if (isRecursive) {
          const renderService = this.injector.get(RenderService);
          currentWidget.children.forEach(childWidget => {
            // eslint-disable-next-line
            renderService.render(childWidget, field.fieldGroup!, widgetRoot, formlyRoot, isInsideQuestion, isRecursive);
          });
        }
      }
    }
    catch (error) {
      this.logger.log(error);
    }
  }

  isAutoWidthLogicNeeded(widget: WidgetsColumnModel) {
    if (widget.width) {
      return false;
    }
    return true;
  }

  getAutoWidth(widget: WidgetsColumnModel): number {
    if (widget.ordinal === 0) {
      // If this is the first column, use the default for first column for current media
      return (33);
    } else if (widget?.columnNumber && widget?.columnNumber > 1) {
      // For the rest of the columns, share the remaining space
      return (66/(widget?.columnNumber-1));
    }

    // Else column hidden
    return 0;
  }
}

